import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import CustomToolTip from "./CustomTooltip";

const CustomSwitchComponent = styled(Switch)(({ theme }) => ({
  width: 25,
  height: 16,
  padding: 0,
  overflow: "visible",
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      margin: "3 3px",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    overflow: "visible",
    transitionDuration: "200ms",
    transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
    "&.Mui-checked": {
      transform: "translateX(9px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#0132A2",
        opacity: 1,
        border: 0,
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#fff",
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#fff",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: "#dbe9fd",
      opacity: 1,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 10,
    height: 10,
    margin: "1px 1px",
    position: "relative",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
    "&::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 25,
      height: 25,
      borderRadius: "50%",
      backgroundColor: "rgba(0, 70, 213, 0.1)", // Light blue color with opacity 0.35
      opacity: 0,
      transition: "opacity 0.3s ease",
      zIndex: 1, // Ensure it is behind the thumb
    },
    "&:hover::after": {
      opacity: 1,
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 12,
    backgroundColor: "#B3C7F3",
    opacity: 1,
    overflow: "visible",
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),
  },
}));

function CustomSwitch({
  checked,
  onChange,
  disabled = false,
  tooltipTitle = null,
}) {
  const [localChecked, setLocalChecked] = useState(checked);

  useEffect(() => {
    setLocalChecked(checked);
  }, [checked]);

  const switchComponent = (
    <CustomSwitchComponent
      checked={localChecked}
      onChange={onChange}
      disabled={disabled}
    />
  );

  return (
    <div>
      {tooltipTitle ? (
        <CustomToolTip title={tooltipTitle}>
          <span>{switchComponent}</span>
        </CustomToolTip>
      ) : (
        switchComponent
      )}
    </div>
  );
}

export default CustomSwitch;
